import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MediaPlayerService {
  private currentlyPlaying = new BehaviorSubject<string | null>(null);
  currentlyPlaying$ = this.currentlyPlaying.asObservable();

  constructor() { }

  // Enregistre l'ID du média en cours de lecture
  setCurrentlyPlaying(mediaId: string | null) {
    this.currentlyPlaying.next(mediaId);
  }

  // Vérifie si un média spécifique est en cours de lecture
  isPlaying(mediaId: string): boolean {
    return this.currentlyPlaying.value === mediaId;
  }

  // Arrête la lecture de tous les médias
  stopAll() {
    this.currentlyPlaying.next(null);
  }
}
